export var graphOptions = {
	responsive: true,
	maintainAspectRatio: false, // leave this as false, see builder dashboard as an example.
	scales: {
		yAxes: [
			{
				ticks: {
					beginAtZero: true,
					userCallback: function (label, index, labels) {
						// when the floored value is the same as the value we have a whole number
						if (Math.floor(label) === label) {
							return label
						}
					},
				},
			},
		],
	},
}

var full = "rgba(10,97,223,1)"
export var graphTheme = {
	global: {
		legend: {
			display: false,
		},
		tooltips: {
			displayColors: false,
		},
		elements: {
			line: {
				backgroundColor: "rgba(48,87,108,.8)",
				borderColor: full,
			},
			point: {
				backgroundColor: full,
			},
		},
	},
}
